import React, { Component } from "react";
import PropTypes from "prop-types";
import Analytics from "../../service/Analytics";

class StripeTease extends Component {
  constructor(props) {
    super(props);
    this.aOrB = props.providerId % 2;
  }

  componentDidMount() {
    if (this.aOrB) {
      Analytics.writeEvent("Stripe Pitch", {
        view: "A",
      });
    } else {
      Analytics.writeEvent("Stripe Pitch", {
        view: "B",
      });
    }
  }

  render() {
    let testCopy;

    if (this.aOrB) {
      testCopy = (
        <p
          style={{
            fontStyle: "italic",
          }}
        >
          Having trouble receiving payment from a customer? We&apos;ve got a solution for that! Let our system do the
          hard work by securely collecting payment from your customers. Sign up with Stripe today!
        </p>
      );
    } else {
      testCopy = (
        <p
          style={{
            fontStyle: "italic",
          }}
        >
          Make it dead simple for your customers to pay you with Payment Collection, Powered by Stripe. For new or
          infrequent clients, get paid in less than 72 hours sharing a link directly to their inbox. No more chasing
          down payments.
          <br />
          <br />
          No additional charge from Tourbuzz to use. Typical credit card processing fees apply through free Stripe
          invoicing account.
        </p>
      );
    }

    const { stripeAuthUrl } = this.props;

    return (
      <div
        style={{
          marginBottom: "5px",
        }}
      >
        {testCopy}
        <a className="connect-with-stripe-btn-wrapper" href={stripeAuthUrl}>
          <img className="connect-with-stripe-btn" src="/www/img/stripe-blue-on-light.png" alt="connect with stripe" />
        </a>
      </div>
    );
  }
}

StripeTease.propTypes = {
  stripeAuthUrl: PropTypes.string.isRequired,
  providerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default StripeTease;
